import { useTaxonomyContext } from "../../../../../contexts/Taxonomy/TaxonomyContext";

export const useProductAttributesLabel = (selectedIds: number[]): string => {
  const { productAttributes } = useTaxonomyContext();

  return selectedIds.length > 1
    ? selectedIds.length + " selected"
    : productAttributes.reduce((label, productAttribute) => {
        if (productAttribute.id === selectedIds[0])
          return (label = productAttribute.name);

        const childrenProductAttribute =
          productAttribute.childrenAttributes.find(
            ({ id }) => id === selectedIds[0]
          );

        return childrenProductAttribute
          ? (label = childrenProductAttribute.name)
          : label;
      }, "") || "All";
};
